import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

import { useVibeHost } from '@common/location-layer/composables/useVibeHost'

const isCommunitiesPath = (path: string) => path === '/communities' || path.startsWith('/communities/')

/** ClientPortal's home (its breadcrumb's Home, the dashboard): on a vibe host, the app's home. */
const CLIENTPORTAL_HOME = '/dashboard'

/**
 * On an AI App Builder vibe host ClientPortal serves only `/communities`; every other path
 * belongs to the vibe app, so leaving `/communities` is a full page load on that host.
 *
 * The `00.` prefix sorts it first in this layer, and this layer's global middleware runs
 * before every other layer's, so it exits before `auth.global` can redirect in-app.
 */
export default defineNuxtRouteMiddleware(to => {
  if (!useVibeHost() || isCommunitiesPath(to.path)) return

  return navigateTo(to.path === CLIENTPORTAL_HOME ? '/' : to.fullPath, { external: true })
})
